import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DataTableModule } from "../data-table/data-table.module";
import { PieChartComponent } from "./pie-chart.component";
import { GetPropsPipe } from "./pipes/get-labels.pipe";

@NgModule({
  declarations: [
    // Component
    PieChartComponent,
    // Pipes
    GetPropsPipe,
  ],
  imports: [CoreModule, DataTableModule],
  exports: [PieChartComponent, GetPropsPipe],
})
export class PieChartModule {}
